// extracted by mini-css-extract-plugin
module.exports = {"application":"index_application__2R_7Y","step":"index_step__2lVB2","form":"index_form__2L-QB","button__box":"index_button__box__1gVIb","button__item":"index_button__item__fiPr9"};